module.exports = __webpack_public_path__ + "static/img/index-banner1.0591b7ec.png";